/*=========================================================================================
  File Name: moduleAuthActions.js
  Description: Auth Module Actions
  ----------------------------------------------------------------------------------------
  Item Name: Vuesax Admin - VueJS Dashboard Admin Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/

import router from "@/router";
import { endTalentSession } from "@/services/logout";

export default {
  updateUsername({ commit }, payload) {
    payload.user
      .updateProfile({
        displayName: payload.username
      })
      .then(() => {
        if (payload.closeAnimation) payload.closeAnimation();

        // If username update is success
        // update in localstorage
        let newUserData = Object.assign({}, payload.user.providerData[0]);
        newUserData.displayName = payload.username;
        commit("UPDATE_AUTHENTICATED_USER", newUserData);

        // If reload is required to get fresh data after update
        // Reload current page
        if (payload.isReloadRequired) {
          router.push(router.currentRoute.query.to || "/");
        }
      })
      .catch(err => {
        if (payload.closeAnimation) payload.closeAnimation();

        payload.notify({
          time: 8800,
          title: "Error",
          text: err.message,
          iconPack: "feather",
          icon: "icon-alert-circle",
          color: "danger"
        });
      });
  },

  updateAuthenticatedUser({ commit }, payload) {
    commit("UPDATE_AUTHENTICATED_USER", payload);
  },

  addToken: ({ commit }, payload) => commit("addToken", payload),

  addUser: ({ commit }, payload) => commit("addUser", payload),

  clearAuthState: ({ commit }) => commit("clearAuthState"),

  signOut: async ({ commit }, payload) => {
    const { router } = payload;
    const { params } = router.history.current;

    // Reset PostHog session and identity on logout
    try {
      if (window.posthog && typeof window.posthog.reset === "function") {
        window.posthog.reset();
      }
    } catch (_) {}

    // Antes de limpar o storage: o interceptor ainda precisa do userToken no
    // localStorage para montar o header.
    await endTalentSession();

    // Reseta o token em memoria ANTES de limpar o storage; senao o
    // vuex-persistedstate regrava o token antigo no sessionStorage.
    commit("clearAuthState");

    localStorage.clear();
    sessionStorage.clear();

    router.push({
      name: "login",
      params
    });
  }
};
